import { AuthorizationRequestData } from 'apex-ui-services'
import { values } from 'lodash'

export enum PermissionsEnum {
  AccountApexInternalAndCorrespondentRead = 'account.apex_internal_and_correspondent.read',
  AccountRead = 'account.read',
  AccountRestrictClose = 'account.restrict.close',
  TradingKillSwitchRestrictionsGet = 'tradingkillswitch.restrictions.get',
  TradingKillSwitchRestrictionsUpdate = 'tradingkillswitch.restrictions.update',
}

export const ALL_REQUESTED_PERMISSIONS: string[] = values(PermissionsEnum)

export const convertToAuthRequest = (permissions: string[]) => {
  return permissions.map(permission => {
    return {
      permission,
    } as AuthorizationRequestData
  })
}
